module.exports = __webpack_public_path__ + "static/media/contacts-mobile.e1f40630.jpg";